import { createSelector } from 'reselect';
import { RoleTypes } from '../../utils/constants/comman';

const selectUser = (state) => state.user;

export const selectCurrentUser = createSelector([selectUser], (user) => user);

export const selectUserIsManager = createSelector([selectUser], (user) => user?.roles?.includes(RoleTypes.Manager));
